import React from 'react';
import { motion } from 'framer-motion';
import { Quote, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import Card from './Card';
import SectionHeader from './SectionHeader';

const Testimonials = () => {
  const featuredTestimonials = [
    {
      quote:
        "The event proved to be highly informative and inspiring, playing a significant role in enhancing students' environmental awareness, competitive spirit, and overall confidence.",
      name: 'Ashok Pant',
      role: 'Principal',
      school: "Gyan Vigyan Children's Academy",
      location: 'Hawalbagh, Almora, Uttarakhand',
    },
    {
      quote:
        'The online quiz provided valuable insight and awareness regarding the environment. Such initiatives play a vital role in fostering environmental awareness, analytical thinking, and intellectual growth among young learners.',
      name: 'Principal',
      role: 'Principal',
      school: 'Academic Heights World School',
      location: 'Pitampura, New Delhi',
    },
    {
      quote:
        'Students benefit from this exam in many ways, as they learn how to conserve biodiversity at their local level and compete with other students in great and simple ways.',
      name: 'Rattan Singh',
      role: 'Principal I/C',
      school: 'Jawahar Navodaya Vidyalaya',
      location: 'Lari, Lahaul & Spiti, Himachal Pradesh',
    },
    {
      quote:
        'Our experience with the SNEAC 2025–26 Quiz Competition was highly enriching and very well coordinated. It encouraged our students to think critically, participate with confidence, and expand their knowledge.',
      name: 'K. K. Pant',
      role: 'Headmaster',
      school: 'Koormanchal Academy',
      location: 'Almora, Uttarakhand',
    },
    {
      quote:
        'Participation in the SNEAC programme was well‑organised and beneficial for our students, supporting value‑based learning and social awareness.',
      name: 'Principal',
      role: 'Principal',
      school: 'Himalaya Public Sr. Sec. School',
      location: 'Rohini, Delhi',
    },
    {
      quote:
        'The Swadhyay National Environment Awareness online quiz gave our students a valuable learning experience that strengthened awareness, speed, and analytical thinking.',
      name: 'Headmistress',
      role: 'Headmistress',
      school: 'D.A.V. Public School, Jhanjra Area',
      location: 'Paschim Bardhaman, West Bengal',
    },
    {
      quote:
        'Conducting the Swadhyay National Environment Awareness Quiz at our school reflected sincere dedication and hard work, and strongly supported our efforts to build environmental consciousness.',
      name: 'Naresh Kumar Sharma',
      role: 'Principal',
      school: 'DAV Public School BSPS Surangani',
      location: 'District Chamba, Himachal Pradesh',
    },
  ];



  return (
    <section className="bg-gradient-to-br from-gray-50 to-blue-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader
          title="Voices of Appreciation"
          subtitle="What institutions and communities say about our initiatives"
        />

        <div className="relative mt-12 overflow-hidden w-full">
          {/* Continuous Marquee */}
          <div className="flex w-fit animate-[marquee_40s_linear_infinite] hover:[animation-play-state:paused] gap-6">
            {[...featuredTestimonials, ...featuredTestimonials].map((testimonial, index) => (
              <div
                key={index}
                className="min-w-[280px] sm:min-w-[320px] lg:min-w-[360px] max-w-[360px] flex-shrink-0"
              >
                <Card className="h-full">
                  <div className="p-6 flex flex-col h-full">
                    <div className="mb-4">
                      <Quote className="w-10 h-10 text-primary-600 opacity-30" />
                    </div>

                    <p className="text-gray-700 italic mb-6 flex-grow leading-relaxed text-sm">
                      "{testimonial.quote}"
                    </p>

                    <div className="border-t border-gray-200 pt-4">
                      <p className="font-bold text-gray-900 text-base">
                        {testimonial.name}
                      </p>
                      <p className="text-sm text-primary-600 font-medium">
                        {testimonial.role}
                      </p>
                      <p className="text-sm text-gray-600 mt-1">
                        {testimonial.school}
                      </p>
                      <p className="text-xs text-gray-500 mt-0.5">
                        {testimonial.location}
                      </p>
                    </div>
                  </div>
                </Card>
              </div>
            ))}
          </div>
        </div>

        {/* View All Button */}
        <div className="text-center mt-12">
          <Link to="/testimonials">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="inline-flex items-center gap-2 bg-primary-600 text-white px-8 py-3 rounded-lg font-semibold shadow-lg hover:bg-primary-700 transition-colors"
            >
              View All Testimonials
              <ArrowRight size={20} />
            </motion.button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;